<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // 删除loading元素
    let loadDom = document.getElementById("loading");
    document.body.removeChild(loadDom);
  },
};
</script>

<style lang="less">
#app {
  // font-family: "PingFangSC-Regular, PingFang SC";
  font-family: "PingFangSC-Medium, PingFang SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  font-size: 14px;
  color: #45494d;
  overflow-y: auto;
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  background: #f5f7fa;
  height: 100%;
  overflow-y: hidden;
  font-family: "-apple-system,BlinkMacSystemFont,HelveticaNeue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif";
}
.large-ele-input__ .el-input__inner {
  width: 240px;
  height: 36px;
}
.small-ele-input__ .el-input__inner {
  width: 160px;
  height: 36px;
}
.fl {
  float: left;
}

.fr {
  float: right;
}

ul {
  list-style: none;
}
a {
  text-decoration: none;
}
.iconfont {
  color: #006aff;
}
.icon-sousuo,
.icon-gengduo {
  color: #ced2d9;
}
::-webkit-scrollbar {
  width: 6px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1; /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}

.linkto {
  color: #006aff;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
}
/* message 跟随内容大小 */
.el-message {
  min-width: 80px!important;
  padding: 15px 30px!important;
  margin-top: 32px;
}
.message-bule-style {
  background: #e8f1ff;
  .el-icon-info {
    color: #187aff;
  }
  .el-message__content {
    color: #187aff;
  }
}
.el-message-box {
  padding-bottom: 20px;
  .el-message-box__header {
    padding: 20px 20px 0px;
  }
  .el-message-box__content {
    margin-top: 22px;
    padding: 10px 20px;
    margin-bottom: 22px;
  }
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
.el-message-box .el-button--default:hover {
  background: #ecf5ff;
  color: #176de6;
  border-color: #176de6;
}
.el-message-box .el-button--primary:hover {
  background: #006aff;
  border-color: #006aff;
  color: #fff;
}
.el-dialog {
  .el-dialog__title {
    font-weight: bold;
  }
}
.el-dialog.auto-scroll {
  .el-dialog__header {
    padding: 20px 20px 2px;
  }
  .el-dialog__body {
    max-height: 500px;
    overflow-y: auto;
  }
  .el-dialog__footer {
    padding: 20px;
  }
}

.tag {
  margin-right: 8px;
  font-size: 14px;
  color: #006aff;
  cursor: default;
}
.mb16 {
  margin-bottom: 16px;
}

.el-input__inner {
  padding: 8px 30px 8px 12px !important;
  border: 1px solid #dcdfe6 !important;
  box-sizing: border-box;
}
.el-date-editor .el-input__inner {
  padding-left: 30px !important;
}
.el-input__inner:hover {
  border-color: #c2c4cc !important;
}
.el-input__inner:focus {
  border-color: #3388ff !important;
}
.el-form-item__label {
  padding-right: 16px !important;
}
.el-form-item {
  margin-bottom: 30px;
}
.el-radio-group {
  .el-radio {
    margin-bottom: 8px;
  }
}
.dialog-title {
  color: #363940;
  font-size: 14px;
  font-weight: bold;
}
.el-main{
  overflow: hidden!important;
}
// 侧边栏样式
.el-menu--popup-right-start {
  padding: 0!important;
  min-width: 164px !important;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
</style>
